/*
 * @Author: lhg
 * @Date: 2023-4-20
 * @Description:
 */
import React, { memo, useState, useEffect } from "react";
import styles from "./DialogOpenApp.module.scss";
import link_to_app_image from "src/assets/img/dialog_open_app/link_to_app_image.jpg";
import utils, { openAppOrToDeeplink } from "src/utils";

const DialogOpenApp = (props: any): JSX.Element => {
  const [show, setShow] = useState(true);
  const [isMobile, setIsMobile] = React.useState(false);

  // 关闭
  function close() {
    setShow(false);
  }

  // 打开或下载 app
  function openApp() {
    openAppOrToDeeplink("dialog_open_app");
  }

  useEffect(() => {
    setIsMobile(utils.myBrowserOS().isMobile);
  });

  return !show || !isMobile ? (
    <></>
  ) : (
    <div className={styles.wrap}>
      <div className={styles.container}>
        {/* 关闭按钮 */}
        <div className={styles.btn_close} onClick={() => close()}>
          <div className={styles.icon}></div>
        </div>
        {/* banner 图片 */}
        <div className={styles.img_wrap}>
          <img className={styles.img} src={link_to_app_image} />
        </div>
        {/* 底部内容 */}
        <div className={styles.info}>
          <div className={styles.title}>Try a better way?</div>
          <div className={styles.desc}>
            It's great to continue using Fotor in your browser, but we must
            admit that downloading our mobile app allows for a better
            experience. Give it a try?
          </div>
          {/* 按钮组 */}
          <div className={styles.bottom}>
            <button
              id="goart_dialog_ad_btn_cancel"
              className={styles.btn_cancel}
              onClick={() => close()}
            >
              Cancel
            </button>
            <button
              id="goart_dialog_ad_btn_get_to_app"
              className={styles.btn_open_app}
              onClick={() => openApp()}
            >
              Get to App
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(DialogOpenApp);
